<script lang="ts">
	import type { PoiData } from '$lib/components/pois/types';
	import { getMapLayoutContext } from '$lib/components/map/map-layout-context';
	import ButtonMarker from '$lib/components/map/markers/ButtonMarker.svelte';
	import PoiMarkerContent from '$lib/components/map/markers/markerContent/PoiMarkerContent.svelte';
	import { usePopupState } from '$lib/components/map/popup/usePopupState.svelte';

	interface Props {
		poi: PoiData;
		detailedView?: boolean;
		isSelectedLocation?: boolean;
		onclick?: (poi: PoiData) => void;
	}

	const {
		poi,
		detailedView = false,
		isSelectedLocation = false,
		onclick,
	}: Props = $props();

	const { hoveredPoiId } = getMapLayoutContext();
	const isHovered = $derived($hoveredPoiId === poi.id);
	const { setPopupState } = usePopupState();

	function handleMarkerClick() {
		setPopupState({ activePoiId: undefined, open: false, poi: undefined });
		onclick?.(poi);
	}

</script>

<ButtonMarker
	lngLat={[poi.coordinates.lng, poi.coordinates.lat]}
	markerOptions={{
		anchor: 'bottom',
		// Add an offset to the marker to account for the height of the marker arrow.
		offset: [0, -4],
	}}
	class={['absolute z-infront rd-1 bg-transparent hover:z-float', (isHovered || isSelectedLocation) && 'z-float']}
	ariaLabel={poi.name}
	onclick={handleMarkerClick}
>
	<PoiMarkerContent
		{poi}
		{detailedView}
		{isSelectedLocation}
		tag="span"
		iconTag="span"
	/>
</ButtonMarker>
